var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconionicIosCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.575,
    height: 16.223,
    viewBox: "0 0 17.575 16.223",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-calendar",
    "data-name": "Icon ionic-ios-calendar",
    transform: "translate(-3.375 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_764",
    "data-name": "Trazado 764",
    d: "M19.26,6.75H17.57V7.764a.339.339,0,0,1-.338.338h-.676a.339.339,0,0,1-.338-.338V6.75H8.107V7.764a.339.339,0,0,1-.338.338H7.093a.339.339,0,0,1-.338-.338V6.75H5.065a1.7,1.7,0,0,0-1.69,1.69V19.931a1.7,1.7,0,0,0,1.69,1.69h14.2a1.7,1.7,0,0,0,1.69-1.69V8.44A1.7,1.7,0,0,0,19.26,6.75ZM19.6,19.424a.847.847,0,0,1-.845.845H5.572a.847.847,0,0,1-.845-.845v-7.6a.339.339,0,0,1,.338-.338h14.2a.339.339,0,0,1,.338.338Z",
    transform: "translate(0 -0.898)",
    fill: "#b2a169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_765",
    "data-name": "Trazado 765",
    d: "M10.352,4.838a.339.339,0,0,0-.338-.338H9.338A.339.339,0,0,0,9,4.838V5.852h1.352Z",
    transform: "translate(-2.245)",
    fill: "#b2a169"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_766",
    "data-name": "Trazado 766",
    d: "M26.1,4.838a.339.339,0,0,0-.338-.338h-.676a.339.339,0,0,0-.338.338V5.852H26.1Z",
    transform: "translate(-8.532)",
    fill: "#b2a169"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconionicIosCalendar);
export default __webpack_public_path__ + "static/media/Icon ionic-ios-calendar.7afc1349243b41bc7c257f1c915403c3.svg";
export { ForwardRef as ReactComponent };